<template>
  <el-link
    type="primary"
    :underline="false"
    @click.stop="openLoadingList"
  >
    <el-icon :name="loading ? 'loading' : 'printer'" />
    {{ label }}
  </el-link>
</template>
<script>
export default {
  props: {
    id: {
      required: true,
    },
    label: {
      required: false,
      default: 'Rakodási lista nyomtatása',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async openLoadingList() {
      this.loading = true;
      try {
        const response = await axios.get(`api/desadvs/${this.id}/loading-list`, {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/pdf'
          },
        });

        const newBlob = new Blob([response], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
      } catch (e) {
      }
      this.loading = false;
    },
  },
};
</script>
